import React from 'react';
import { connect } from 'react-redux';

import { MatchesContainer } from 'app/modules/Betting';
import GridHeader from 'app/modules/Live/Content/components/GridHeader';
import EmptyGame from 'app/widgets/EmptyGame';

import { groupedTournamentsBySportIdSelector } from '../../selectors/gridPresentation';
import TournamentTable from './TournamentTable';

import styles from './SportGrid.module.scss';

function LiveSportGrid({ sportId, tournamentIds }) {
  if (!tournamentIds.length) {
    return <EmptyGame />;
  }

  return (
    <div className={styles.content}
         data-test="content-container">
      <GridHeader sportId={sportId}
                  shouldBeLink />

      <MatchesContainer>
        {tournamentIds.map((tournamentId) => (
          <TournamentTable key={tournamentId}
                           sportId={sportId}
                           tournamentId={tournamentId} />
        ))}
      </MatchesContainer>
    </div>
  );
}

const mapStateToProps = (state, { sportId }) => ({
  tournamentIds: Array.from(groupedTournamentsBySportIdSelector(state, sportId).keys()),
});

export default connect(mapStateToProps)(LiveSportGrid);
